import { createStyles, makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import type { CSSProperties } from 'react'
import barCode from '../../images/barCode.png'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex'
    },
    formControl: {
      margin: theme.spacing(3)
    },
    formElement: {
      padding: '20px'
    },
    title: {
      textAlign: 'center'
    },
    alert: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper
    },
    paper: {
      padding: theme.spacing(4),
      textAlign: 'center',
      color: theme.palette.text.secondary
    },
    Logo: {
      backgroundImage: '../../../assets/logos/wms_copy.png'
    },
    button: {
      marginLeft: 10,
      marginTop: 10
    },
    secondary: {
      backgroundColor: 'rgb(220, 0, 78)',
      color: 'white',
      '&:hover': {
        backgroundColor: '#9a1236',
        color: 'white'
      }
    },
    sucess: {
      backgroundColor: '#4caf50',
      color: 'white',
      '&:hover': {
        backgroundColor: '#357a38',
        color: 'white'
      }
    },

    warning: {
      backgroundColor: '#ffea00',
      color: 'white',
      '&:hover': {
        backgroundColor: '#b2a300',
        color: 'white'
      }
    },
    difference: {
      backgroundColor: '#f48fb1',
      color: 'white',
      '&:hover': {
        backgroundColor: '#d81b60',
        color: 'white'
      }
    },
    manage: {
      '&:hover': {
        backgroundColor: '#027db2',
        color: 'white'
      }
    },
    filterButton: {
      borderRadius: '30px',
      height: '28px',
      color: 'black',
      fontSize: '0.7em'
    },
    cover: {
      width: 150,
      height: 150
    },
    barCode: {
      backgroundImage: `url(${barCode})`
    },
    chipColorOk: {
      color: 'white'
    },
    chipColorError: {
      color: 'black'
    },
    image: {
      '&:hover': {
        color: '#2196f3',
        cursor: 'pointer'
      }
    },
    elementText: {
      textAlignLast: 'initial'
    },
    grid: {
      minHeight: 400,
      width: '100%',
      backgroundColor: '#ebebeb',
      padding: 3,
      borderRadius: 10,
      alignContent: 'center'
    },
    actionButton: {
      marginTop: '10px'
    },
    details: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    },
    content: {
      flex: 'auto'
    },
    excessButton: {
      backgroundColor: '#FFF548',
      color: 'black',
      '&:hover': {
        backgroundColor: '#DFD501',
        color: 'black'
      }
    },
    btnDownload: {
      marginLeft: '20px',
      paddingLeft: '20px'
    }
  })
)

export const numberStyles: CSSProperties = {
  marginLeft: '10px',
  WebkitAppearance: 'none'
}
